export { Text } from './text'
